<div class="pie-chart">
  <div style="display:flex;" fxLayout="column" fxLayoutAlign="space-around center">
    <div style="width: 100%;">
      <div [chart]="currentChart"></div>
    </div>
  </div>
</div>